import OffreFormController from './offre.form.controller';

export default {
    template: require('./offre.form.html'),
    controller: OffreFormController
};
